export const moduleNames = {
  FAVORITE_PRODUCT: 'FAVORITE_PRODUCT',
  FAVORITE_PRODUCTS: 'FAVORITE_PRODUCTS',
  LOOK: 'LOOK',
  ARTISTS: 'ARTISTS',
  MULTIPLE_LOOK: 'LOOKS',
  VIDEO: 'VIDEO',
  LOCATIONS: 'LOCATIONS',
  SHAREABLE_LINK: 'SHAREABLE_LINK',
  BANNER: 'BANNER',
  EVENTS: 'EVENTS',
};

export const modules = [
  {
    id: 1,
    name: moduleNames.LOOK,
    nameTranslationPath: 'Looks.look',
    descriptionTranslationPath: 'Looks.singleLookModuleDescription',
    iconClassName: 'bi bi-image',
    disabled: true,
  },
  {
    id: 2,
    name: moduleNames.MULTIPLE_LOOK,
    nameTranslationPath: 'Looks.title',
    descriptionTranslationPath: 'Looks.moduleDescription',
    iconClassName: 'bi bi-images',
  },
  {
    id: 3,
    name: moduleNames.FAVORITE_PRODUCT,
    nameTranslationPath: 'favouriteProducts.singularTitle',
    descriptionTranslationPath: 'favouriteProducts.singleProductModuleDescription',
    iconClassName: 'bi bi-lightbulb',
    disabled: true,
  },
  {
    id: 4,
    name: moduleNames.FAVORITE_PRODUCTS,
    nameTranslationPath: 'favouriteProducts.title',
    descriptionTranslationPath: 'favouriteProducts.productsModuleDescription',
    iconClassName: 'bi bi-lightbulb-fill',
  },
  {
    id: 5,
    name: moduleNames.BANNER,
    nameTranslationPath: 'banners.title',
    descriptionTranslationPath: 'banners.moduleDescription',
    iconClassName: 'bi bi-card-image',
  },
  {
    id: 6,
    name: moduleNames.VIDEO,
    nameTranslationPath: 'videos.title',
    descriptionTranslationPath: 'videos.moduleDescription',
    iconClassName: 'bi bi-camera-video',
  },
  {
    id: 7,
    name: moduleNames.ARTISTS,
    nameTranslationPath: 'artists.title',
    descriptionTranslationPath: 'artists.moduleDescription',
    iconClassName: 'bi bi-people',
  },
  {
    id: 8,
    name: moduleNames.EVENTS,
    nameTranslationPath: 'events.title',
    descriptionTranslationPath: 'events.moduleDescription',
    iconClassName: 'bi bi-calendar-event',
  },
  {
    id: 9,
    name: 'shareableLink',
    nameTranslationPath: 'shareableLink.title',
    descriptionTranslationPath: 'shareableLink.subtitle',
    iconClassName: 'bi bi-link-45deg',
    disabled: true,
  },
];

export const contentManagerModules = modules.filter((module) =>
  [moduleNames.BANNER, moduleNames.VIDEO].includes(module.name),
);
